import React from "react";
import ItemList from "../../components/webshop/ItemList";

const ItemsPage = () => {
    return <ItemList/>
}

export default ItemsPage;
